import { render, staticRenderFns } from "./ListadoEntregas.vue?vue&type=template&id=a404afee"
import script from "./ListadoEntregas.vue?vue&type=script&lang=js"
export * from "./ListadoEntregas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports